
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { TransactionsTableGroup } from '~/interfaces/tables';
import TextInput from '~/components/Inputs/Text.vue';
import TransactionsTableItem from './TransactionsTableItem.vue';

@Component({ components: { TransactionsTableItem, TextInput } })
export default class TransactionsTable extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly items!: unknown[];

  @Prop({ type: String, default: 'group' }) readonly groupBy!: string;

  @Prop({ type: Number, default: 1 }) readonly currentPage!: number;

  @Prop({ type: Number, default: 0 }) readonly totalItems!: number;

  @Prop({ type: Number, default: 5 }) readonly itemsPerPage!: number;

  @Prop(Boolean) readonly showGroups!: boolean;

  @Prop(Boolean) readonly loading!: boolean;

  @Prop(Boolean) readonly colorCodedNegatives!: boolean;

  search = '';

  get paginationText() {
    const currentIndex = ((this.currentPage - 1) * this.itemsPerPage) + 1;
    const endIndex = currentIndex + this.itemsPerPage - 1;
    const endIndexLabel = this.totalItems < endIndex ? this.totalItems : endIndex;
    return `${currentIndex}-${endIndexLabel} of ${this.totalItems}`;
  }

  get nextDisabled() {
    return this.currentPage >= Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get previousDisabled() {
    return this.currentPage <= 1;
  }

  get groups() {
    if (this.showGroups) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return new Set(this.items.map((item: any) => item[this.groupBy]));
    }
    return [];
  }

  next() {
    if (!this.nextDisabled) {
      this.$emit('update:currentPage', this.currentPage + 1);
    }
  }

  previous() {
    if (!this.previousDisabled) {
      this.$emit('update:currentPage', this.currentPage - 1);
    }
  }

  getGroupItems(group: TransactionsTableGroup) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.items.filter((item: any) => item[this.groupBy] === group);
  }

  @Watch('search')
  onSearch(val: string) {
    this.$emit('search', val);
  }
}
